
import React, { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../actions/userActions'

const Signin = () => {
    const [email, setEmail] = useState('kennedy@gmail.com')
    const [password, setPassword] = useState('123456')

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const userLogin = useSelector((state) => state.userLogin)
    const { loading, error, userInfo } = userLogin

    useEffect(() => {
        if (userInfo) {
            navigate('/profile')
        }
    }, [userInfo, navigate])

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch(login(email, password))
    }

    const showError = () => (
        <div
            className="alert alert-danger rounded-lg border-0 shadow-sm mb-4"
            style={{
                display: error ? '' : 'none',
                backgroundColor: '#fee',
                borderLeft: '4px solid #dc3545'
            }}
        >
            <i className="fas fa-exclamation-triangle me-2"></i>
            {error}
        </div>
    )

    const showLoading = () =>
        loading && (
            <div className="d-flex justify-content-center mb-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )

    const signInForm = () => (
        <form onSubmit={submitHandler}>
            <div className="mb-4">
                <label className="form-label fw-medium mb-2" htmlFor="inputEmailAddress" style={{ color: '#5B9BD5', fontSize: '0.9rem' }}>EMAIL ADDRESS</label>
                <input
                    className="form-control form-control-lg border-0 shadow-sm"
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    id="inputEmailAddress"
                    placeholder="Enter your email address"
                    value={email}
                    style={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        color: '#666',
                        fontSize:'14px',
                    }}
                />
            </div>
            <div className="mb-4">
                <label className="form-label fw-medium mb-2" htmlFor="inputPassword" style={{ color: '#5B9BD5', fontSize: '0.9rem' }}>PASSWORD</label>
                <input
                    className="form-control form-control-lg border-0 shadow-sm"
                    type="password"
                    id="inputPassword"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        color: '#666',
                        fontSize:'14px',
                    }}
                />
            </div>
            <div className="mb-4">
                <div className="form-check">
                    <input className="form-check-input" id="rememberPasswordCheck" type="checkbox" style={{ accentColor: '#5B9BD5' }} />
                    <label className="form-check-label" htmlFor="rememberPasswordCheck" style={{ color: '#666', fontSize: '0.9rem' }}>
                        Remember password
                    </label>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-4">
                <a href="#" className="text-decoration-none" style={{ color: '#5B9BD5', fontSize: '0.9rem' }}>
                    Forgot Password?
                </a>
                <button
                    className="btn btn-lg px-4 py-2 fw-medium border-0 shadow-sm"
                    type="submit"
                    style={{
                        backgroundColor: '#5B9BD5',
                        color: 'white',
                        borderRadius: '25px',
                        minWidth: '120px',
                        fontSize:'14px'
                    }}
                >
                    {loading ? 'Logging in...' : 'LOGIN'}
                </button>
            </div>
        </form>
    )

    return (
        <div style={{ backgroundColor: '#f0f4f8', minHeight: '100vh' }}>
            <div className="container">
                <div className="row justify-content-center align-items-center min-vh-100">
                    <div className="col-lg-5 col-md-7 py-5">
                        {showError()}
                        {showLoading()}
                        <div className="card border-0 shadow-lg" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                            <div
                                className="card-header text-center"
                                style={{
                                    background: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)',
                                    color: 'white',
                                    borderRadius: '15px 15px 0px 0px',
                                    padding: '20px 25px',
                                    borderBottom: 'none'
                                }}
                            >
                                <h2 className="mb-0 fw-normal" style={{ fontSize: '1.8rem' }}>
                                    Login
                                </h2>
                            </div>
                            <div className="card-body bg-white px-4 py-5">
                                {signInForm()}
                            </div>
                            <div className="card-footer bg-white border-0 text-center py-4">
                                <div style={{ color: '#666', fontSize: '0.9rem' }}>
                                    Need an account?{' '}
                                    <Link to="/signup" className="text-decoration-none fw-medium" style={{ color: '#5B9BD5' }}>
                                        Sign up!
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer className="mt-auto py-4" style={{ backgroundColor: 'white', borderTop: '1px solid #e9ecef' }}>
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between">
                        <div style={{ color: '#6c757d', fontSize: '0.85rem' }}>
                            Copyright &copy; Your Website 2025
                        </div>
                        <div style={{ fontSize: '0.85rem' }}>
                            <a href="#" className="text-decoration-none me-3" style={{ color: '#6c757d' }}>
                                Privacy Policy
                            </a>
                            <a href="#" className="text-decoration-none" style={{ color: '#6c757d' }}>
                                Terms & Conditions
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Signin
